module.exports = __webpack_public_path__ + "20250721160708/img/peoples-stat.ae272bea.png";